import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ShieldCheck } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white" data-testid="forgot-page">
      <div className="w-full max-w-sm border border-border p-8 rounded-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 bg-[#2563EB] text-white flex items-center justify-center rounded-sm">
            <ShieldCheck size={18} weight="bold" />
          </div>
          <span className="font-display font-semibold">HRMS Suite</span>
        </div>
        <h2 className="font-display text-2xl tracking-tight font-medium">Forgot password</h2>
        <p className="text-sm text-[#475569] mt-1">We'll log a reset token to the backend console.</p>
        {done ? (
          <div className="mt-6 text-sm text-[#12B886] border border-[#12B886]/30 bg-[#12B886]/5 px-3 py-2 rounded-sm">
            If the email exists, a reset link has been generated. Check the backend logs.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-[10px] uppercase tracking-[0.18em] font-semibold text-[#475569]">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 rounded-sm" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-sm bg-[#2563EB] hover:bg-[#1D4ED8] text-sm uppercase tracking-wider" data-testid="forgot-submit">
              Send reset link
            </Button>
          </form>
        )}
        <div className="mt-6 text-xs text-[#475569]">
          <Link to="/login" className="hover:text-[#2563EB]">← Back to login</Link>
        </div>
      </div>
    </div>
  );
}
